<template>
    <div v-if="show" class="l-status-container" :class="[lClass]" :style="{background:bgColor}">
        <template v-if="custom">
            <slot />
        </template>
        <template v-else>
            <img v-if="image" :class="['left-img', lImageClass]" :src="image" />
            <img
                v-else
                :class="[type=='success'||type=='error'?'left-img':'top-img', type=='address'?'ad-img':'', lImageClass]"
                :src="typeImage"
            />
            <span v-if="describe" class="status-text l-describe-class">{{describe}}</span>
            <span v-else class="status-text" :class="[lDescribeClass]">{{typeText}}</span>
            <l-button
                v-if="buttonText"
                :class="lButtonClass"
                style="margin-top:40px"
                @click.native="onBtn"
            >{{buttonText}}</l-button>
            <l-button
                v-if="!buttonText && type =='network'"
                :class="lButtonClass"
                style="margin-top:40px"
                @click.native="onBtn"
            >重新加载</l-button>
            <l-button
                v-if="!buttonText && type =='cart'"
                :class="lButtonClass"
                style="margin-top:40px"
                @click.native="onBtn"
            >去逛逛</l-button>
        </template>
    </div>
</template>

<script>
import ButtonVue from './Button.vue'
export default {
    name: 'StatusShow',
    components: {
        'l-button': ButtonVue
    },
    mixins: [],
    props: {
        lClass: {
            type: String,
            default: ''
        },
        lImageClass: {
            type: String,
            default: ''
        },
        lButtonClass: {
            type: String,
            default: ''
        },
        lDescribeClass: {
            type: String,
            default: ''
        },
        show: {
            type: Boolean,
            default: false
        },
        custom: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'success'
            // observer: '_changeStatus'
        },
        image: {
            type: String,
            default: ''
        },
        typeImage: {
            type: String,
            default: ''
        },
        describe: {
            type: String,
            default: ''
        },
        buttonText: {
            type: String,
            default: ''
        },
        typeText: {
            type: String,
            default: ''
        },
        bgColor: {
            type: String,
            default: '#fff'
        }
    },
    data() {
        return {}
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {
        onBtn(e) {
            this.$emit('lintap')
        }
    }
}
</script>
<style lang='stylus'>
.l-status-container
    position: fixed
    height: 100%
    width: 100%
    top: 0
    right: 0
    display: flex
    flex-direction: column
    align-items: center
    background-color: #fff
.ad-img
    margin-top: 130px
    width: 99px !important
    height: 102px !important
.top-img
    margin-top: 65px
    width: 132px
    height: 102px
.left-img
    width: 110px
    height: 92px
    margin-top: 130px
.status-text
    margin-top: 20px
    font-size: 15px
    color: #45526b
</style>
